import React, { Component } from 'react'
import './selectionitemsimple.scss'
class SelectionItemSimple extends Component {
	constructor(props) {
		super(props)
		this.state = {
			info: props.info ? props.info : []
		}
	}

	render() {
		let classes = ['vbui--selectionitemsimple', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes}>
				<div className="img-carrier">
					<img src={this.props.imgURL} alt="" />
				</div>
				{this.state.info.map((line, i) => {
					return (
						<p key={i} className={line.className}>
							{line.text}
						</p>
					)
				})}
			</div>
		)
	}
}

export default SelectionItemSimple
